import React from "react";

import styles from "./ProjectStatusBadge.module.scss";

interface ProjectStatusBadgeProps {
  status: number;
}

const ProjectStatusBadge = ({ status }: ProjectStatusBadgeProps) => {
  const statusToText: { [key: number]: string } = {
    0: "Ready",
    1: "Initialising",
    2: "Error",
    3: "Creating",
  };

  return (
    <div
      className={`${styles.badge} ${status == 1 && styles.initialising} ${status == 2 && styles.error} ${status == 3 && styles.creating}`}
    >
      {statusToText[status] ?? "Unknown"}
    </div>
  );
};

export default ProjectStatusBadge;
